import {
    AutogenLayoutLoadBoardTruckSearchSlideout
} from "../../general/src/autogen/AutogenLayoutLoadBoardTruckSearchSlideout";

export class LoadBoardTruckSearchSlideout extends AutogenLayoutLoadBoardTruckSearchSlideout{

    async postDataSources(): Promise<boolean> {
        try {
            await this.mainDataSource.post();
            return true;
        } catch {
            return false;
        }
    }

}

